import { JsonObject, JsonProperty } from 'json2typescript';

import { DocumentProductInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('DocumentProduct')
export class DocumentProduct implements DocumentProductInterface {
    @JsonProperty('Factsheet', StringAdapter, true)
    private _factsheet: string = undefined;

    private _costAndTaxes: string = undefined;

    @JsonProperty('Q1Factsheet', StringAdapter, true)
    private _q1Factsheet: string = undefined;

    @JsonProperty('Q2Factsheet', StringAdapter, true)
    private _q2Factsheet: string = undefined;

    @JsonProperty('Q3Factsheet', StringAdapter, true)
    private _q3Factsheet: string = undefined;

    @JsonProperty('Q4Factsheet', StringAdapter, true)
    private _q4Factsheet: string = undefined;

    @JsonProperty('FirstHalfFactsheet', StringAdapter, true)
    private _firstHalfFactsheet: string = undefined;

    @JsonProperty('SecondHalfFactsheet', StringAdapter, true)
    private _secondHalfFactsheet: string = undefined;

    @JsonProperty('AnnualReport', StringAdapter, true)
    private _annualReport: string = undefined;

    @JsonProperty('KIID', StringAdapter, true)
    private _kIID: string = undefined;

    @JsonProperty('Q1ManagementReport', StringAdapter, true)
    private _q1ManagementReport: string = undefined;

    @JsonProperty('Q2ManagementReport', StringAdapter, true)
    private _q2ManagementReport: string = undefined;

    @JsonProperty('Q3ManagementReport', StringAdapter, true)
    private _q3ManagementReport: string = undefined;

    @JsonProperty('Q4ManagementReport', StringAdapter, true)
    private _q4ManagementReport: string = undefined;

    @JsonProperty('ManagementRegulation', StringAdapter, true)
    private _managementRegulation: string = undefined;

    @JsonProperty('FullProspectus', StringAdapter, true)
    private _fullProspectus: string = undefined;

    @JsonProperty('SustainabilityAnnex', StringAdapter, true)
    private _sustainabilityAnnex: string = undefined;

    get sustainabilityAnnex(): string {
        return this._sustainabilityAnnex;
    }

    get factsheet(): string {
        return this._factsheet;
    }

    get costAndTaxes(): string {
        return this._costAndTaxes;
    }

    set costAndTaxes(value: string) {
        this._costAndTaxes = value;
    }

    get q1Factsheet(): string {
        return this._q1Factsheet;
    }

    get q2Factsheet(): string {
        return this._q2Factsheet;
    }

    get q3Factsheet(): string {
        return this._q3Factsheet;
    }

    get q4Factsheet(): string {
        return this._q4Factsheet;
    }

    get firstHalfFactsheet(): string {
        return this._firstHalfFactsheet;
    }

    get secondHalfFactsheet(): string {
        return this._secondHalfFactsheet;
    }

    get annualReport(): string {
        return this._annualReport;
    }

    get kIID(): string {
        return this._kIID;
    }

    get q1ManagementReport(): string {
        return this._q1ManagementReport;
    }

    get q2ManagementReport(): string {
        return this._q2ManagementReport;
    }

    get q3ManagementReport(): string {
        return this._q3ManagementReport;
    }

    get q4ManagementReport(): string {
        return this._q4ManagementReport;
    }

    get managementRegulation(): string {
        return this._managementRegulation;
    }

    get fullProspectus(): string {
        return this._fullProspectus;
    }
}
